import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, Users, Star, MapPin } from 'lucide-react';
export function Hero() {
  return <section className="bg-gradient-to-b from-[#EDE6D8] to-[#F5F0E8] py-8 md:py-20 px-4 pt-[15px] pb-[15px]" data-id="element-139">
      <div className="max-w-7xl mx-auto" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-4 md:mb-8" data-id="element-141">
          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-4 md:mb-6" data-id="element-142">
            <span className="bg-white px-2 py-1 md:px-4 md:py-1.5 rounded-full text-[10px] md:text-xs font-medium border border-[#2B2724]/10" data-id="element-143">
              PDF Digital
            </span>
            <span className="bg-white px-2 py-1 md:px-4 md:py-1.5 rounded-full text-[10px] md:text-xs font-medium border border-[#2B2724]/10" data-id="element-144">
              Acceso Inmediato
            </span>
            <span className="bg-white px-2 py-1 md:px-4 md:py-1.5 rounded-full text-[10px] md:text-xs font-medium border border-[#2B2724]/10" data-id="element-145">
              Principiante - Avanzado
            </span>
          </div>

          <h1 className="md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6 text-[24px] leading-tight" data-id="element-146">
            Megapack <span className="text-[#C2613A]" data-id="element-147">Muebles Japandi</span>
            <br data-id="element-148" />
            Desde cero.
          </h1>

          {/* Mockup directly below the title */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="max-w-[240px] sm:max-w-xs md:max-w-md mx-auto mb-4 md:mb-8" data-id="element-149">
            <img src="https://cdn.magicpatterns.com/uploads/fJvkW2McUTmB1D6tMAgGrT/Diseno_sin_titulo.png" alt="Megapack Muebles Japandi - Ebook digital con planos, materiales y paso a paso para fabricar muebles Japandi en casa" className="w-full h-auto" data-id="element-150" />
          </motion.div>

          <p className="md:text-xl mb-2 md:mb-4 max-w-3xl mx-auto text-[#2B2724]/80 text-[12px]" data-id="element-151">
            Megapack Muebles Japandi 6 Tomos + 5 Bonos
          </p>

          <p className="text-sm md:text-lg mb-6 md:mb-8 max-w-4xl mx-auto leading-relaxed" data-id="element-152">
            Tu sistema completo para fabricar muebles Japandi en casa y generar
            hasta <strong data-id="element-153">$3000 USD por mes</strong>: planos, materiales, paso a
            paso, negocio y marca. Sin improvisar.
          </p>

          <motion.a href="#pricing" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-[#C2613A] hover:bg-[#A84F2E] text-white px-6 py-3 md:px-8 md:py-4 rounded-lg text-base md:text-lg font-bold transition-colors shadow-lg mb-6 md:mb-8" data-id="element-154">
            💥 QUIERO MI MEGAPACK JAPANDI AHORA
          </motion.a>

          <div className="flex flex-wrap justify-center gap-3 md:gap-6 text-[10px] md:text-sm" data-id="element-155">
            <div className="flex items-center gap-1 md:gap-2" data-id="element-156">
              <ShieldCheck className="w-4 h-4 md:w-5 md:h-5 text-[#C2613A]" data-id="element-157" />
              <span data-id="element-158">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1 md:gap-2" data-id="element-159">
              <CreditCard className="w-4 h-4 md:w-5 md:h-5 text-[#C2613A]" data-id="element-160" />
              <span data-id="element-161">Pago seguro Mercado Pago</span>
            </div>
            <div className="flex items-center gap-1 md:gap-2" data-id="element-162">
              <Users className="w-4 h-4 md:w-5 md:h-5 text-[#C2613A]" data-id="element-163" />
              <span data-id="element-164">+300 Fabricantes</span>
            </div>
            <div className="flex items-center gap-1 md:gap-2" data-id="element-165">
              <Star className="w-4 h-4 md:w-5 md:h-5 text-[#C2613A] fill-[#C2613A]" data-id="element-166" />
              <span data-id="element-167">4.9 Rating</span>
            </div>
            <div className="flex items-center gap-1 md:gap-2" data-id="element-168">
              <MapPin className="w-4 h-4 md:w-5 md:h-5 text-[#C2613A]" data-id="element-169" />
              <span data-id="element-170">Todo Argentina</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}